import React, { useMemo, useContext } from 'react';
import classNames from 'classnames';
import ContentFeed from '../../ContentFeed';
import ProductCard from '../../ProductCard';
import HeroV2 from '../common/HeroV2';
import Section1 from '../common/Section1';
import Section2 from '../common/Section2';
import Section3 from '../common/Section3';
import Section4 from '../common/Section4';
import CategoryAnchorLinks from '../common/CategoryAnchorLinks';
import CategoryGroup from '../common/CategoryGroup';
import Promo from '../common/Promo';
import Faqs from '../../Faqs';
import useVisibleProducts from '../../../hooks/useVisibleProducts';
import useElevarEvent from '../../../hooks/useElevarEvent';
import { convertToElevarDataItem } from '../../../utils';
import { AuthContext } from '../../../context/auth-context';

const ns = `version-a-plp`;

const VersionA = ({ productsVisible = {}, category = {}, location }) => {
  const rootClassnames = useMemo(() => classNames({ [`${ns}`]: true }), []);
  const { nextAmount } = productsVisible;

  const { state: authState } = useContext(AuthContext);
  const { userProperties } = authState;

  const {
    products,
    plpHeroImages,
    heroHeadline,
    copyOne,
    productsOne,
    copyTwo,
    productsTwo,
    copyThree,
    productsThree,
    copyFour,
    productsFour,
    copyFive,
    productsFive,
    copySix,
    productsSix,
    copySeven,
    productsSeven,
    copyEight,
    productsEight,
    contentSection1Image,
    contentSection1Copy,
    contentSection2Image,
    contentSection2Copy,
    contentSection4Image,
    contentSection4Copy,
    videoContentSectionHeadline,
    videoContentSectionUrl,
    faqs,
    promo,
    promoText,
    promoAmount,
  } = category;

  const initialProductListAmount = 8;

  const productView = (p, index) => (
    <ProductCard
      location={location}
      category={category}
      product={p}
      key={p.id}
      index={index}
      hideQuickshop
      promo={promo?.value}
      promoAmount={promoAmount?.value}
      hideTag
    />
  );

  const {
    impressions,
    handleLoadMore,
    handleFilteredProducts,
  } = useVisibleProducts(products, location, initialProductListAmount);

  const initialProducts = useMemo(
    () => products.slice(0, initialProductListAmount),
    [products, initialProductListAmount],
  );
  const initialVisibleProducts = initialProducts.map((product, index) => convertToElevarDataItem({ item: product, index, location }));
  const allImpressions = [ ...initialVisibleProducts, ...impressions ];

  useElevarEvent({
    location,
    productLength: impressions?.length,
    eventType: 'dl_view_item_list',
    allImpressions,
    impressions,
    userProperties,
  });

  return (
    <section className={rootClassnames}>
      <HeroV2 heroHeadline={heroHeadline?.value} plpHeroImages={plpHeroImages} category={category} />

      {promo?.value === 'true' && (
        <Promo
          promoHeadline={promoText?.value?.split('|')[0]}
          promoCopy={promoText?.value?.split('|')[1]}
        />
      )}

      {contentSection1Image && contentSection1Copy && (
        <Section1
          contentSection1Image={contentSection1Image}
          contentSection1Copy={contentSection1Copy}
        />
      )}

      <div className="container">
        <h3 style={{ marginBottom: '18px' }}>Omega-3 Categories</h3>

        <CategoryAnchorLinks category={category} classnames={ns} />

        <div className={`${ns}__items`}>
          <h3>All Omega-3s</h3>
          <ContentFeed
            location={location}
            page="category"
            items={products}
            itemView={productView}
            initialVisibleAmount={initialProductListAmount}
            nextVisibleAmount={nextAmount}
            onLoadMore={handleLoadMore}
          />
        </div>
      </div>

      {contentSection2Copy && contentSection2Image && (
        <Section2
          contentSection2Image={contentSection2Image}
          contentSection2Copy={contentSection2Copy}
        />
      )}

      {productsOne !== null && (
        <CategoryGroup
          ns={ns}
          location={location}
          category={category}
          title={copyOne?.value.split('|')[0]}
          productList={productsOne?.value}
          items={products}
          headline={copyOne?.value.split('|')[1]}
          showHr
          onFilteredProducts={handleFilteredProducts}
        />
      )}

      {productsTwo !== null && (
        <CategoryGroup
          ns={ns}
          location={location}
          category={category}
          title={copyTwo?.value.split('|')[0]}
          productList={productsTwo?.value}
          items={products}
          headline={copyTwo?.value.split('|')[1]}
          showHr
          onFilteredProducts={handleFilteredProducts}
        />
      )}

      {productsThree !== null && (
        <CategoryGroup
          ns={ns}
          location={location}
          category={category}
          title={copyThree?.value.split('|')[0]}
          productList={productsThree?.value}
          items={products}
          headline={copyThree?.value.split('|')[1]}
          onFilteredProducts={handleFilteredProducts}
        />
      )}

      {videoContentSectionHeadline && videoContentSectionUrl && (
        <Section3
          videoContentSectionHeadline={videoContentSectionHeadline}
          videoContentSectionUrl={videoContentSectionUrl}
        />
      )}

      {productsFive !== null && (
        <CategoryGroup
          ns={ns}
          location={location}
          category={category}
          title={copyFive?.value.split('|')[0]}
          productList={productsFive?.value}
          items={products}
          headline={copyFive?.value.split('|')[1]}
          showHr
          onFilteredProducts={handleFilteredProducts}
        />
      )}

      {productsSix !== null && (
        <CategoryGroup
          ns={ns}
          location={location}
          category={category}
          title={copySix?.value.split('|')[0]}
          productList={productsSix?.value}
          items={products}
          headline={copySix?.value.split('|')[1]}
          onFilteredProducts={handleFilteredProducts}
        />
      )}

      {contentSection4Image && contentSection4Copy && (
        <Section4
          contentSection4Image={contentSection4Image}
          contentSection4Copy={contentSection4Copy}
        />
      )}

      {productsSeven !== null && (
        <CategoryGroup
          ns={ns}
          location={location}
          category={category}
          title={copySeven?.value.split('|')[0]}
          productList={productsSeven?.value}
          items={products}
          headline={copySeven?.value.split('|')[1]}
          showHr
          onFilteredProducts={handleFilteredProducts}
        />
      )}

      {productsFour !== null && (
        <CategoryGroup
          ns={ns}
          location={location}
          category={category}
          title={copyFour?.value.split('|')[0]}
          productList={productsFour?.value}
          items={products}
          headline={copyFour?.value.split('|')[1]}
          showHr
          onFilteredProducts={handleFilteredProducts}
        />
      )}

      {productsEight !== null && (
        <CategoryGroup
          ns={ns}
          location={location}
          category={category}
          title={copyEight?.value.split('|')[0]}
          productList={productsEight?.value}
          items={products}
          headline={copyEight?.value.split('|')[1]}
          onFilteredProducts={handleFilteredProducts}
        />
      )}

      {faqs !== null && <Faqs faqItems={faqs} />}
    </section>
  );
};

export default VersionA;
